import { render } from "./clientSay.vue?vue&type=template&id=45888836&scoped=true"
import script from "./clientSay.vue?vue&type=script&lang=js"
export * from "./clientSay.vue?vue&type=script&lang=js"

import "./clientSay.vue?vue&type=style&index=0&id=45888836&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45888836"]])

export default __exports__